import { jsPDF } from 'jspdf';

function escapeCsv(value) {
  const s = String(value ?? '');
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}

/**
 * Exporta mapa de propostas (CSV/Excel-friendly).
 */
export function exportMapaPropostasExcel(fornecedores, { processoCodigo = '', vencedorCnpj = '' } = {}) {
  const headers = [
    'Empresa',
    'CNPJ',
    'Valor',
    'Prazo execução',
    'Documentação',
    'Data envio',
    'Observação',
    'Mais vantajosa',
  ];
  const lines = [headers.join(';')];
  (fornecedores || []).forEach((f) => {
    lines.push(
      [
        f.empresa,
        f.cnpj,
        f.valor,
        f.prazoExecucao,
        f.documentacao,
        f.dataEnvio,
        f.observacao,
        f.cnpj && f.cnpj === vencedorCnpj ? 'SIM' : '',
      ]
        .map(escapeCsv)
        .join(';')
    );
  });
  const blob = new Blob([`\uFEFF${lines.join('\n')}`], { type: 'text/csv;charset=utf-8' });
  downloadBlob(blob, `mapa-propostas-${processoCodigo || 'processo'}.csv`);
}

/**
 * Exporta mapa de propostas em PDF simples.
 */
export function exportMapaPropostasPdf(
  fornecedores,
  { processoCodigo = '', vencedorCnpj = '', observacao = '' } = {}
) {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
  let y = 40;
  doc.setFontSize(14);
  doc.text(`Mapa comparativo de propostas — ${processoCodigo || 'Processo'}`, 40, y);
  y += 24;
  doc.setFontSize(10);
  (fornecedores || []).forEach((f, idx) => {
    if (y > 520) {
      doc.addPage();
      y = 40;
    }
    const vant = f.cnpj && f.cnpj === vencedorCnpj ? ' [MAIS VANTAJOSA]' : '';
    doc.text(
      `${idx + 1}. ${f.empresa || '—'} | CNPJ ${f.cnpj || '—'} | R$ ${f.valor ?? '—'}${vant}`,
      40,
      y
    );
    y += 14;
    doc.text(
      `Prazo: ${f.prazoExecucao || '—'} | Doc: ${f.documentacao || '—'} | Envio: ${f.dataEnvio || '—'}`,
      48,
      y
    );
    y += 14;
    if (f.observacao) {
      const lines = doc.splitTextToSize(`Obs: ${f.observacao}`, 720);
      doc.text(lines, 48, y);
      y += lines.length * 12 + 8;
    } else {
      y += 8;
    }
  });
  if (observacao) {
    y += 8;
    const lines = doc.splitTextToSize(`Parecer: ${observacao}`, 720);
    if (y + lines.length * 12 > 540) {
      doc.addPage();
      y = 40;
    }
    doc.text(lines, 40, y);
  }
  doc.save(`mapa-propostas-${processoCodigo || 'processo'}.pdf`);
}
